

var wjtHttp = {
    get(vm,url,params,isLoading,then,error){
        var loading
        if(isLoading){
            loading = vm.$loading({
                lock: true,
                text: '加载中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.1)'
              });
        }
        var token = vm.$cookies.get('token')
        if(token && token.length > 0){
            vm.axios.defaults.headers.common['Authorization'] = token
        }
        vm.axios.get(url,{params:params})
        .then((res)=>{
            console.log(res)
            if(loading){
                loading.close()
            }
            if(res.data.code == 401){
                vm.$cookies.remove('token')
                vm.$router.push('/Login')
                sessionStorage.clear()
            }
            if(then){
                then(res)
            }
        }).catch((err)=>{
            if(loading){
                loading.close()
            }
            console.log(err)
            if(error){
                error(err)
            }
        })
    },
    delete(vm,url,params,isLoading,then,error){
        var loading
        if(isLoading){
            loading = vm.$loading({
                lock: true,
                text: '加载中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.1)'
              });
        }
        var token = vm.$cookies.get('token')
        if(token && token.length > 0){
            vm.axios.defaults.headers.common['Authorization'] = token
        }
        vm.axios.delete(url,{params:params})
        .then((res)=>{
            console.log(res)
            if(loading){
                loading.close()
            }
            if(res.data.code == 401){
                vm.$cookies.remove('token')
                vm.$router.push('/Login')
                sessionStorage.clear()
            }
            if(then){
                then(res)
            }
        }).catch((err)=>{
            if(loading){
                loading.close()
            }
            console.log(err)
            if(error){
                error(err)
            }
        })
    },
    post(vm,url,params,isLoading,then,error){
        var loading
        if(isLoading){
            loading = vm.$loading({
                lock: true,
                text: '加载中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0)'
              });
        }
        var token = vm.$cookies.get('token')
        if(token && token.length > 0){
            vm.axios.defaults.headers.common['Authorization'] = token
        }
        vm.axios.post(url,params)
        .then((res)=>{
            console.log(res)
            if(loading){
                loading.close()
            }
            if(res.data.code == 401){
                vm.$cookies.remove('token')
                vm.$router.push('/Login')
                sessionStorage.clear()
            }
            if(then){
                then(res)
            }
        })
        .catch((err)=>{
            if(loading){
                loading.close()
            }
            console.log(err)
            if(error){
                error(err)
            }
        })
    },
    put(vm,url,params,isLoading,then,error){
        var loading
        if(isLoading){
            loading = vm.$loading({
                lock: true,
                text: '加载中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0)'
              });
        }
        var token = vm.$cookies.get('token')
        if(token && token.length > 0){
            vm.axios.defaults.headers.common['Authorization'] = token
        }
        vm.axios.put(url,params)
        .then((res)=>{
            console.log(res)
            if(loading){
                loading.close()
            }
            if(res.data.code == 401){
                vm.$cookies.remove('token')
                vm.$router.push('/Login')
                sessionStorage.clear()
            }
            if(then){
                then(res)
            }
        })
        .catch((err)=>{
            if(loading){
                loading.close()
            }
            console.log(err)
            if(error){
                error(err)
            }
        })
    }
}
export default wjtHttp 